<template>
  <div class="balanceListBox">
    <nav-bar :title="$t(title[type])" bg-color="linear-gradient( 133deg, #DBC397 0%, #BA9A66 100%)" left-arrow
      left-color="#000" title-color="#000" />
    <div>
      <div class="msgBox">
        <div class="topBox">
          <p class="title">{{ $t(title[type]) }}</p>
          <p class="price">
            {{ price || 0 }}
            <span v-if="type === '0'" class="doer"> ≈ ${{ balance_amount }}</span>
          </p>
          <p class="btnBox1" v-if="type == 1 || type == 3 || type == 4">
            <span v-if="type == 1" class="btn" @click="router(`/exChange?type=1`)">{{ $t('兑换') }}</span>
            <span v-if="type == 3" class="btn" @click="router(`/exChange?type=2`)">{{ $t('兑换') }}</span>
            <span v-if="type == 3" class="btn" @click="router('/transfer?type=1')">{{ $t('转赠') }}</span>
            <!-- <span v-if="type == 4" class="btn" @click="router('/transfer?type=2')">{{ $t('转赠') }}</span> -->
            <!--<span class="btn" @click="router('/withdraw')">{{ $t('提现') }}</span>-->
          </p>
          <!-- <p class="btnBox1" v-if="type == 4">
            <span class="btn" @click="router('/subReg')">{{ $t('开通子账号') }}</span>
          </p> -->
        </div>
        <div class="listBox">
          <page-list ref="pageList" :api="`/balanceLog/getList?balance_field=${equ[type]}`" :finished-text="$t('没有更多了')" :offset="0"
            @changelist="onListUpdate">
            <div v-for="(item, index) in list" :key="index" class="list">
              <p class="top">
                <span class="left">{{ item.remark }}</span>
                <span class="right">{{ item.amount }}</span>
              </p>
              <p class="time">{{ item.created_at }}</p>
            </div>
          </page-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        type: "",
        price: "",
        balance_amount: "",
        title: ["股权余额", "权益币余额", "铸造币余额", "注册币余额", "子币余额", "燃烧币余额"],
        equ: ["balance", "equity", "mint", "coin", "sub_coin", "burning_coin"],
        list: [],
        timer: null // 定时器ID
      }
    },
    computed: {},
    watch: {
      '$route.query.type': { // 监听路由参数变化
        handler(newVal) {
          if (newVal !== undefined) {
            this.type = newVal;
            this.initData(); // 初始化数据
          }
        },
        immediate: true // 立即执行一次
      }
    },
    methods: {
      // 获取信息
      getMemberInfo() {
        this.$get({
          url: `/member/getMemberInfo`,
          loading: false, // 始终显示loading
          success: (res) => {
            this.price = res.data[[ 'balance', 'equity', 'mint', 'coin', "sub_coin", "burning_coin" ][this.type]]
            this.balance_amount = res.data.balance_amount
          },
          tip: () => {
          }
        })
      },
      // 监听列表更新
      onListUpdate(data) {
        this.list = [...this.list, ...data]
      },
      // 刷新列表数据
      refreshList() {
        this.list = []; // 清空当前列表
        if (this.$refs.pageList) {
          this.$refs.pageList.refresh(); // 调用page-list组件的刷新方法
        }
      },
      // 初始化数据
      initData() {
        this.getMemberInfo();
        this.refreshList();
      },
    },
    created() {
        // 已在watch中处理
      },
    mounted() {
      // 每隔5秒刷新一次数据
        this.getMemberInfo();
        this.refreshList();
    },
    beforeDestroy() {
      // 清除定时器，避免内存泄漏
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  }
</script>

<style lang="less" scoped>
  .balanceListBox {
    width: 100%;
    min-height: 100vh;
    background-color: #446D7A;
    .msgBox {
      position: relative;
      top: -50px;
      .topBox {
        background: linear-gradient(133deg, #DBC397 0%, #BA9A66 100%);
        padding: 80px 30px 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #5e4024;
        .title {
          font-size: 12px;
        }
        .price {
          font-size: 24px;
          font-weight: bold;
          display: flex;
          flex-direction: column;
          .doer {
            font-weight: 400;
            font-size: 18px;
          }
        }
        .btnBox1 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          margin-top: 20px;
          .btn {
            color: #fff;
            font-weight: bold;
            padding: 10px 50px;
            border-radius: 100px;
            background: linear-gradient(to bottom, #6d4a2d, #583f25); // 上浅下深，立体感
            box-shadow: 0 4px 0 #3a2819, /* 下方实心阴影 */
                        0 6px 12px rgba(0, 0, 0, 0.3); // 模糊阴影
            transition: all 0.2s ease;

            &:hover {
              background: linear-gradient(to bottom, #7a5232, #5f4228); // hover 时整体变亮
              box-shadow: 0 4px 0 #3a2819, 0 8px 14px rgba(0, 0, 0, 0.35);
              transform: translateY(-2px); // 微微上浮
            }

            &:active {
              background: linear-gradient(to bottom, #583f25, #3a2819); // 反转渐变，模拟按下
              box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.4); // 内阴影模拟凹陷
              transform: translateY(2px); // 按下去
            }
          }
        }
      }
      .listBox {
        padding: 15px;
        .list {
          padding: 10px;
          border-radius: 10px;
          background-color: #343638;
          margin-bottom: 10px;
          .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 5px;
            .left {
              color: #ffffff;
              font-weight: bold;
            }
            .right {
              color: #dbd3b5;
            }
          }
          .time {
            font-size: 10px;
            color: #6b6d6f;
          }
        }
      }
    }
  }
</style>
